var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(
                                            " 是否能配合「日夜輪班」，若無法配合，請說明： "
                                          ),
                                          _c("p", { staticClass: "en-text" }, [
                                            _vm._v(
                                              'Can you cooperate with "Day/Night shift rotation", if not, please explain:'
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "field-radio" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCooperation
                                                  .CanShiftWork,
                                              expression:
                                                "workCooperation.CanShiftWork",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.workCooperation.CanShiftWork,
                                              true
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCooperation,
                                                "CanShiftWork",
                                                true
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("是 (Yes)")]),
                                      ]),
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCooperation
                                                  .CanShiftWork,
                                              expression:
                                                "workCooperation.CanShiftWork",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              _vm.workCooperation.CanShiftWork,
                                              false
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCooperation,
                                                "CanShiftWork",
                                                false
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("否 (No)")]),
                                      ]),
                                    ]),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: {
                            rules: {
                              required: !_vm.workCooperation.CanShiftWork
                                ? true
                                : false,
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      !_vm.workCooperation.CanShiftWork
                                        ? _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ])
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(" 原因說明 "),
                                          _c(
                                            "span",
                                            { staticClass: "en-text" },
                                            [_vm._v("Explanation")]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "field-value" },
                                      [
                                        _c("el-input", {
                                          staticClass: "w-100",
                                          attrs: {
                                            type: "textarea",
                                            rows: 4,
                                            maxlength: "200",
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value:
                                              _vm.workCooperation
                                                .CanShiftWorkDesc,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workCooperation,
                                                "CanShiftWorkDesc",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workCooperation.CanShiftWorkDesc",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(
                                            " 是否能配合「出差/派駐」，請說明： "
                                          ),
                                          _c("p", { staticClass: "en-text" }, [
                                            _vm._v(
                                              'Can you cooperate with "business trips/dispatchments", please explain:'
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "field-value" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "w-100",
                                            attrs: { placeholder: "請選擇" },
                                            model: {
                                              value:
                                                _vm.workCooperation
                                                  .CanOfficeTripOrStation,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.workCooperation,
                                                  "CanOfficeTripOrStation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "workCooperation.CanOfficeTripOrStation",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "否 No",
                                                value: 0,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "可接受1-3個月 1-3 months acceptable",
                                                value: 1,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "可接受半年 Acceptable for half a year",
                                                value: 2,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "可接受1年 Acceptable for 1 year",
                                                value: 3,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  "可接受2年以上 Acceptable for more than 2 years",
                                                value: 4,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: {
                            rules: {
                              required:
                                _vm.workCooperation.CanOfficeTripOrStation ===
                                "否"
                                  ? true
                                  : false,
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _vm.workCooperation
                                        .CanOfficeTripOrStation === "否"
                                        ? _c("span", { staticClass: "mark" }, [
                                            _vm._v(" * "),
                                          ])
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(" 原因說明 "),
                                          _c(
                                            "span",
                                            { staticClass: "en-text" },
                                            [_vm._v("Explanation")]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "field-value" },
                                      [
                                        _c("el-input", {
                                          staticClass: "w-100",
                                          attrs: {
                                            type: "textarea",
                                            rows: 4,
                                            maxlength: "200",
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value:
                                              _vm.workCooperation
                                                .CanOfficeTripOrStationDesc,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workCooperation,
                                                "CanOfficeTripOrStationDesc",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workCooperation.CanOfficeTripOrStationDesc",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(
                                            " 是否有任何個人、家庭因素會影響工作配合度、工作時間、需常請假…等事項 ，請說明： "
                                          ),
                                          _c("p", { staticClass: "en-text" }, [
                                            _vm._v(
                                              "Are there are any personal or family factors will affect cooperation with work, working hours, often need to take leaves ... and so on, please explain:"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "field-radio" }, [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCooperation
                                                  .HasLackOfWorkCooperation,
                                              expression:
                                                "workCooperation.HasLackOfWorkCooperation",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.workCooperation
                                                .HasLackOfWorkCooperation,
                                              true
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCooperation,
                                                "HasLackOfWorkCooperation",
                                                true
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("是 (Yes)")]),
                                      ]),
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workCooperation
                                                  .HasLackOfWorkCooperation,
                                              expression:
                                                "workCooperation.HasLackOfWorkCooperation",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              _vm.workCooperation
                                                .HasLackOfWorkCooperation,
                                              false
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workCooperation,
                                                "HasLackOfWorkCooperation",
                                                false
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("否 (No)")]),
                                      ]),
                                    ]),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("ValidationProvider", {
                          attrs: {
                            rules: {
                              required: _vm.workCooperation
                                .HasLackOfWorkCooperation
                                ? true
                                : false,
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("div", { staticClass: "field-title" }, [
                                      _vm.workCooperation
                                        .HasLackOfWorkCooperation
                                        ? _c("span", { staticClass: "mark" }, [
                                            _vm._v(" * "),
                                          ])
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _vm._v(" 原因說明 "),
                                          _c(
                                            "span",
                                            { staticClass: "en-text" },
                                            [_vm._v("Explanation")]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "field-value" },
                                      [
                                        _c("el-input", {
                                          staticClass: "w-100",
                                          attrs: {
                                            type: "textarea",
                                            rows: 4,
                                            maxlength: "200",
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value:
                                              _vm.workCooperation
                                                .HasLackOfWorkCooperationDesc,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workCooperation,
                                                "HasLackOfWorkCooperationDesc",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workCooperation.HasLackOfWorkCooperationDesc",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    errors[0]
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveWorkCooperation)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }